import React from "react";
import { useTranslation } from 'react-i18next';

import FunctionalTableComponent from "../../components/table/FunctionalTableComponent";
import fields from "./OperationParametrFormConfig";
import columns from "./OperationParametrTableConfig";
import renderUtils from "../../helpers/renderUtils";
import utils from "../../helpers/utils";

const OperatingParametersComponent = ({
                                          setLoader,
                                          className,
                                          api,
                                          pagination = false,
                                          initialData,
                                          header = true,
                                          onParametersUpdate,
                                          addFromGroup,
                                          addFromGroupFields,
                                          deleteApi,
                                          fromModal,
                                          addAsList,
                                          editWithId,
                                          editable,
                                          editApi,
                                          readOnly
                                      }) => {
    const { t } = useTranslation();

    const selectTemplateField = {
        name: "template",
        label: t("parameters.template"),
        column: 1,
        className: "mw-inherit",
        type: "dictionary",
        searchBy: function (option) {
            return utils.join(option.name, option.value, option.comment)
        },
        useSelect: true,
        dictionary: "operatingParameterTemplate",
        mandatory: false,
        renderOption: (option) => <>{renderUtils.renderOperatingParameterTemplate(option)}</>,
        placeholder: t("parameters.search_working_parameters"),
    }


    return (
        <>


            <FunctionalTableComponent
                onDataUpdate={onParametersUpdate}
                initialData={initialData}
                title={t("object_types.operating_parameter_template")}
                className={className}
                creationTitle={t("parameters.add_working_parameter")}
                creationFields={{
                    config: fields.config,
                    fields: [selectTemplateField].concat(fields(t).fields)
                }
                }
                editionFields={function () {
                    return fields
                }}
                remove={true}
                columns={columns}
                header={header}
                api={api}
                setLoader={setLoader}
                readOnly={readOnly}
                addFromGroup={addFromGroup}
                addFromGroupFields={addFromGroupFields}
                width={12}
                editable={editable}
                pagination={pagination}
                fromModal={fromModal}
                addAsList={addAsList}
                editWithId={editWithId}
                deleteApi={deleteApi}
                editApi={editApi}
                deleteModalTitle={t("confirmations.parameter_deletion_title")}
                deleteModalDescription={t("confirmations.are_you_sure_delete_parameter")}
            />

        </>
    );
};


export default OperatingParametersComponent;
